import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';

function* fetchVisionEquipment({ visionEquipmentParams }) {
  try {
    const { data } = yield call(api.get, {
      route:
        `SocialDV/GetDetailSociaDVByEquipmentId/` +
        visionEquipmentParams.equipId,
    });
    console.log(data);
    const visionEquipmentData = data;
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setVisionEquipment({ visionEquipmentData }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_VISION_EQUIPMENT, fetchVisionEquipment),
  ]);
}
